<div class="tw-flex tw-flex-row">
  <div class="content_options {{viewType}} {{style}} tw-flex tw-items-center" [class.tw-w-full]="size==='responsive'">
    <div class="tw-flex tw-flex-col" [class.tw-w-full]="autocomplete || size==='responsive'" [ngClass]="{'!tw-flex-row tw-items-baseline tw-gap-2': hasInlineLabel}">
      <label *ngIf="label" class="tw-mb-1 tw-text-sm tw-font-medium tw-text-gray-700">
        {{prefixTranslate+label | translate }}
        <i *ngIf="tooltip" 
           class="fas fa-info-circle tw-ml-1 tw-cursor-help" 
           [ngbTooltip]="tooltip" 
           container="body"
           placement="right"
           [autoClose]="false"></i>
      </label>
      <ng-container *ngIf="!autocomplete">
        <select 
          #selectElement
          [name]="name"
          class="tw-block tw-rounded-md tw-border-none tw-py-2 tw-px-3 tw-text-base !tw-min-w-40 {{viewType}}"
          [ngClass]="{'tw-bg-gray-100 tw-cursor-not-allowed': disabled, 'tw-border-red-500': style==='error', 'tw-w-full': size==='responsive', 'tw-w-[120px]': size!=='responsive'}"
          [value]="selected === null ? '' : selected"
          [disabled]="disabled"
          (change)="changeMetric($event.target.value)">
          <option *ngIf="labelAction" [value]="''" disabled>{{labelAction}}</option>
          <option *ngIf="selected === null && !labelAction" [value]="''"></option>
          <option *ngFor="let item of options" [value]="item.value">
            {{item.name | translate}}
          </option>
        </select>
      </ng-container>
      <ng-container *ngIf="autocomplete">
        <input
          matInput
          class="tw-block tw-w-full tw-rounded-md tw-border-2 tw-py-2 tw-px-3 tw-text-base {{viewType}}"
          [ngClass]="{'tw-bg-gray-100 tw-cursor-not-allowed': disabled}"
          [matAutocomplete]="auto"
          [formControl]="autoControl"
          [disabled]="disabled"
          >
        <mat-autocomplete
          autoActiveFirstOption
          #auto="matAutocomplete"
          (optionSelected)="changeMetric($event.option.value)"
          [displayWith]="displayFn.bind(this)">
          <mat-option *ngFor="let item of filteredOptions | async" [value]="item.name">
            {{item.name | translate}}
          </mat-option>
        </mat-autocomplete>
      </ng-container>
    </div>
    <i *ngIf="description && description !== ''" container="body" class="description fas fa-question-circle tw-ml-2" [ngbTooltip]="tooltipDescription"></i>
  </div>
</div>

<ng-template #tooltipDescription>
  <div [innerHtml]="description"></div>
</ng-template>

